const axios = require('axios')
const config = require('./config')

const defaults = {
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  },
  json: true
}

defaults.baseURL = config.default[process.env.NODE_ENV || 'development'].apiUrl

export default axios.create(defaults)
